var map = {
	"./black/yinliangjia.png": "2A/e",
	"./blue/yinliangjia.png": "YhdP",
	"./white/yinliangjia.png": "dBNa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dKmm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/yinliangjia\.png$
// module id = dKmm
// module chunks = 24